export default {
  namespaced: true,
  state: {
    modals: [
      { name: "changePassword", isOpen: false },
      { name: "updateUserData", isOpen: false },
      { name: "addPatientModal", isOpen: false },
      { name: "editPatientModal", isOpen: false },
      { name: "authCodeModal", isOpen: false },
      { name: "checkoutCardModal", isOpen: false },
      { name: "dateOfTheVisitModal", isOpen: false },
      { name: "addCurrentPatientModal", isOpen: false },
      { name: "deleteConfirmModal", isOpen: false },
      { name: "addAddressModal", isOpen: false },
      { name: "addInvoiceDataModal", isOpen: false },
      { name: "savedAddressesModal", isOpen: false },
      { name: "editAddressModal", isOpen: false },
      { name: "confirmModal", isOpen: false },
      { name: "askInvoiceModal", isOpen: false },
      { name: "editChildModal", isOpen: false },
      { name: "doctorAskForAccessToHistoryModal", isOpen: false },
      { name: "changePhoneNumberModal", isOpen: false },
      { name: "addInvoiceModal", isOpen: false },
      { name: "roles", isOpen: false },
      { name: "privacyPolicyModal", isOpen: false },
      { name: "patientTermsOfUseModal", isOpen: false },
      { name: "authModal", isOpen: false },
      { name: "doctorLeaveMeetingModal", isOpen: false },
      { name: "endVisitConfirmationModal", isOpen: false },
      { name: "callMeLaterChangeDateModal", isOpen: false },
      { name: "stripePaymentModal", isOpen: false },
      { name: "uploadFileModal", isOpen: false },
      { name: "addWeightDataModal", isOpen: false },
      { name: "changeWeightGoalModal", isOpen: false },
    ],
  },
  getters: {
    isOpenModal: (state) => (name) => {
      return state.modals.find((modal) => modal.name === name).isOpen;
    },
    getModalData: (state) => (name) => {
      return state.modals.find((modal) => modal.name === name);
    },
  },
  mutations: {
    closeModal(state, name) {
      const index = state.modals.findIndex((modal) => modal.name === name);
      state.modals[index] = { name: state.modals[index].name, isOpen: false };
    },
    openModal(state, name) {
      const currentModal = state.modals.find((modal) => modal.name === name);
      currentModal.isOpen = true;
    },
    openModalCallback(state, payload) {
      const defaultCallbacks = { onConfirm: () => {}, onCancel: () => {} };
      const index = state.modals.findIndex(
        (modal) => modal.name === payload.name
      );

      state.modals[index] = {
        ...state.modals[index],
        ...defaultCallbacks,
        ...payload,
        isOpen: true,
      };
    },
  },
};
